// extracted by mini-css-extract-plugin
export var hideEditor = "_k1-2";
export var infoIcon = "_k1-3";
export var label = "_k1-1";
export var labelContainer = "_k1-0";
export var readonlyText = "_k1-4";